import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles((t: typeof theme) => ({
  tooltip: {
    textDecorationLine: 'underline',
    textDecorationStyle: 'dotted',
    cursor: 'default',
  },

  icon: { marginRight: '0.5rem' },

  // A raw exception message must not compete with the headline that says
  // whose problem it is.
  detail: { opacity: 0.8, fontSize: '0.9em' },

  tryAgain: { marginLeft: '1rem' },
}))
